import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=35bdafb5&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=js&"
export * from "./Hero.vue?vue&type=script&lang=js&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=35bdafb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdafb5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInputPlate: require('/app/components/base/InputPlate.vue').default,BaseBtn: require('/app/components/base/Btn.vue').default,BaseQrSmart: require('/app/components/base/QrSmart.vue').default,UiLinkApp: require('/app/components/storyblok/ui/LinkApp.vue').default,BaseChatItem: require('/app/components/base/ChatItem.vue').default})
